module.exports = __webpack_public_path__ + "img/i-fast-rewind.8be5ca05.svg";